import React from 'react';
import * as firebase from 'firebase';
import {
  BrowserRouter as Router,
  useLocation,
  useHistory
} from "react-router-dom";
import { NavBarGuest, NavBarAffiliate, NavBarUser } from './NavBar';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import './css/AffiliateGallery.css';

export function AffiliateGalleryView(props) {

  return (
    <div className="gallerypage">
      {!props.initialLoad && props.runThis()}
      {props.initialLoad && !props.photosSet && props.populatePhotos()}
      {props.type_1 == "" ? <NavBarGuest /> : props.type_1 == "Student" ? <NavBarUser /> : <NavBarAffiliate />}
      <h1>Gallery</h1>
      <div className="gal">
      <button className="gallerybtn" onClick={props.history}>Back to Affiliate Page</button>
      </div>
      <ImageGallery items={props.images} />
    </div>
  );
}